(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    window.DGS.WaitForLoad.getInstance().register($('.job-list-spot'));
    $('.job-list-spot').each(function () {
      var $this = $(this);
      $('ul li img[src=""]', $this).hide();
      window.DGS.LoadComplete.getInstance().register($this);
    });
  });
})(jQuery);